/* eslint-disable no-console */
import Joi from 'joi';
import api from '../api';
import * as Types from '../types';

/**
 * Get a leave post from its ID
 *
 * @async
 * @param {Object} queryParams
 * @param {string} queryParams.year
 * @param {string} queryParams.postId
 * @return {Promise<Types.LeavePost>} Response from API under Axios instance
 */
export const getLeavePost = async (queryParams) => {
  const result = await api.get(
    `/calendars/${queryParams.year}/leave-posts/${queryParams.postId}`,
  );

  try {
    await Types.leavePostSchema.validateAsync(result.data);
  } catch (error) {
    console.error(error);
    throw Error(`getLeavePost result do not validate leavePostSchema : ${error}`);
  }

  return result.data;
};

/**
 * Get  leave posts from a given year
 *
 * @async
 * @param {Object} queryParams
 * @param {string} queryParams.year
 * @param {Object} params
 * @param {Number|null} params.excludedEndSlotId
 * @param {Number|null} params.includedStartSlotId
 * @param {string|null} [params.resourceId=null]
 * @param {string|null} [params.status=null]
 * @param {string|null} [params.type=null]
 * @return {Promise<Array<Types.LeavePost>>}
 */
export const getLeavePostsList = async (queryParams, params) => {
  const result = await api.get(
    `/calendars/${queryParams.year}/leave-posts`,
    { params },
  );

  try {
    const dataSchema = Joi.array().items(Types.leavePostSchema);
    await dataSchema.validateAsync(result?.data?.data);
  } catch (error) {
    console.error(error);
    throw new Error(`getLeavePostsList result do not validate leavePostSchema : ${error}`);
  }

  return result.data;
};

/**
 * Create a new leave working post
 *
 * @async
 * @param {Object} queryParams
 * @param {string} queryParams.year
 * @param {Object} data
 * @param {string} data.resourceId
 * @param {number} data.includedStartSlotId
 * @param {number} data.excludedEndSlotId
 * @param {string|null} data.comment
 * @param {string|null} data.type
 * @param {number} data.version
 * @return {Promise} Response from API under Axios instance
 */
export const postLeavePost = (queryParams, data) => api.post(
  `/calendars/${queryParams.year}/leave-posts`,
  data,
);

/**
 * Update an existing leave working post
 *
 * @async
 * @param {Object} queryParams
 * @param {string} queryParams.year
 * @param {string} queryParams.postId
 * @param {Object} data
 * @param {string|null} data.resourceId
 * @param {number|null} data.includedStartSlotId
 * @param {number|null} data.excludedEndSlotId
 * @param {string|null} data.comment
 * @param {string|null} data.type
 * @param {number} data.version
 * @return {Promise} Response from API under Axios instance
 */
export const updateLeavePost = (queryParams, data) => api.patch(
  `/calendars/${queryParams.year}/leave-posts/${queryParams.postId}`,
  data,
);
